import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification";
import type { DefaultOperationSuccessResponse } from "~types/response";

const useDeleteRosterPlayer = () => {
  const { sport, organizationId, seasonId, fixtureId } = useParams();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const request = useApi();
  const notification = useNotification();
  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (personId: string) => {
      const url = fixtureId
        ? `${sport}/o/${organizationId}/fixtures/${fixtureId}/persons/${personId}/roster`
        : `${sport}/o/${organizationId}/seasons/${seasonId}/persons/${personId}/roster`;
      return await request(url, {
        method: "DELETE",
      });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        const queryKeyId = fixtureId ? "fixtureRoster" : "seasonRoster";
        await queryClient.invalidateQueries({
          queryKey: [queryKeyId, sport, organizationId, seasonId],
        });
        notification.success({
          message: formatMessage({ id: "roster.delete.success" }),
          placement: "bottomRight",
        });
      }
    },
  });
};

export default useDeleteRosterPlayer;
